import { z } from "zod";

export const tournamentApplySchema = z.object({
    calendarId: z.number(),
    haveProCertificate: z.boolean(),
    email: z.email().optional(),
    region: z.string().optional(),
    termAgreeList: z.object({
        termsId: z.number(),
        isAgreed: z.boolean()
    }).array()
});